/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ramesh Prajapati - ramesh.prajapati@bacancytechnology.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {RestResponse} from '../model';
import {SearchableProvider} from '../model/interface/searchable.provider';
import {ApiHeaders} from './headers';
import {Tag} from '../model/tag';

@Injectable()
export class TagProvider implements SearchableProvider {

  constructor(
    private http: HttpClient
  ) {}

  search(query?: string, id?: string, nonBank?: boolean, lsp?: boolean, page?: number): Observable<RestResponse> {
    // in id we are passing selected tags
    return this.getTags(page ? page : 1, query, id ? JSON.parse(id): '');
  }

  getTags(page: number, query?: string, selected?: Tag[]): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/tag/list?page=${page}` +
        (query ? '&query=' + encodeURIComponent(query) : ''),
      (selected ? selected : null),
      ApiHeaders.getOptions());
  }

  deleteTag(tag: Tag): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/tag/${tag.ID}/delete`, null, ApiHeaders.getOptions());
  }

  deleteReportTag(tag: Tag, reportID: any): Observable<RestResponse> {
    return this.http
      .delete<RestResponse>(`${environment.API_URL}/api/tag/${tag.ID}/report/${reportID}`, ApiHeaders.getOptions());
  }

  addReportTag(tag: Tag, reportID: any): Observable<RestResponse> {
    return this.http
      .put<RestResponse>(`${environment.API_URL}/api/tag/${tag.ID}/report/${reportID}`, null, ApiHeaders.getOptions());
  }

  saveTag(tag: Tag): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/tag`, tag, ApiHeaders.getOptions());
  }

  save(id: string, field: string, value: any): Observable<RestResponse>{
    return null;
  }

  getQuickAccessTags(): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/tag/quick-tags`, ApiHeaders.getOptions());
  }

  getSearchType(): string {
    return 'TAG';
  }
}
